import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DashboardService } from 'app/services/dashboard.service';
import { Grafico, Cuadro } from 'app/domain/dashboard';
import { es } from 'app/domain/publico';
declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'dashboard-app',
    templateUrl: '../../templates/dashboard.component.html',
    styleUrls: ['../../assets/css/dashboard.component.css'],
    providers: [DashboardService]
})

export class DashboardComponent {

    data: any;

    constructor(private dashboard: DashboardService, private _titulo: Title) {

    }

    fechainicio: Date = new Date();
    fechafin: Date = new Date();

    filtrar(finicio, ffin) {
        this.get_cuadros(this.convertirFecha(finicio), this.convertirFecha(ffin));
        this.get_grafico(this.convertirFecha(finicio), this.convertirFecha(ffin));
    }

    lista_cuadro_impo: Array<Cuadro> = new Array<Cuadro>();
    lista_cuadro_expo: Array<Cuadro> = new Array<Cuadro>();

    ls_detalle: Array<Cuadro>;

    data_impo: Cuadro = new Cuadro();
    data_expo: Cuadro = new Cuadro();

    get_cuadros(finicio, ffin) {
        this.dashboard.get_cuadros(finicio, ffin)
            .subscribe(resp => {
                this.ls_detalle = resp;
                this.agregar_totales(resp);
                this.buscar_detalles();
            }, error => {
                //console.log(error);
            })
    }

    buscar_detalles() {
        this.lista_cuadro_impo = new Array<Cuadro>();
        this.lista_cuadro_expo = new Array<Cuadro>();
        for (let i = 0; i < this.ls_detalle.length; i++) {
            switch (this.ls_detalle[i].tipoItem) {
                case "D":
                    switch (this.ls_detalle[i].tipoServicio) {
                        case "1":
                            this.lista_cuadro_impo.push(this.ls_detalle[i]);
                            break;
                        case "2":
                            this.lista_cuadro_expo.push(this.ls_detalle[i])
                            break;
                    }
                    break;
            }
        }
    }

    agregar_totales(lista: Array<Cuadro>) {
        for (let i = 0; i < lista.length; i++) {
            switch (lista[i].tipoItem) {
                case "T":
                    switch (lista[i].tipoServicio) {
                        case "1":
                            this.data_impo = lista[i];
                            break;
                        case "2":
                            this.data_expo = lista[i];
                            break;
                    }
                    break;
            }
        }
    }


    get_grafico(finicio, ffin) {
        this.dashboard.get_grafico(finicio, ffin)
            .subscribe(resp => {
                this.ls_grafico = resp;

                //this.ls_grafico.push({ cantidadRetiro: "1050", cantidadDevolucion: "100", anio: "2017", mes: "11" });
                //this.ls_grafico.push({ cantidadRetiro: "500", cantidadDevolucion: "100", anio: "2017", mes: "10" });

                this.ls_grafico.sort((a, b) => {
                    var dateA: any = Number(a.anio + "" + a.mes), dateB: any = Number(b.anio + "" + b.mes)
                    return dateA + dateB;
                })

                this.armar_grafico(this.ls_grafico);
            }, error => {
                //console.log(error)
            })
    }

    convertirFecha(str: string) {
        var date = new Date(str),
            year = date.getFullYear(),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return year + mnth + day;
    }

    es: any;
    ngOnInit() {
        this._titulo.setTitle("Container Services | Dashboard");
        this.es = es;
        $(".text-header").text("Dashboard")
        this.fechainicio = new Date();
        this.fechafin = new Date();
        if (this.fechafin.getMonth() <= 12)
            this.fechainicio.setMonth(this.fechafin.getMonth() - 6);
        else
            this.fechainicio.setMonth(1);

        this.filtrar(this.fechainicio, this.fechafin);
    }

    ngAfterViewInit() {
        // $('.date-picker').datepicker({ language: 'es-ES', format: 'yyyy/mm/dd' });
    }

    ls_grafico: Array<Grafico> = new Array<Grafico>();

    armar_grafico(ls_grafico: Array<Grafico>) {
        this.data = {
            labels: this.armar_meses(ls_grafico),
            datasets: [
                {
                    label: 'Impo',
                    data: this.armar_cantidad_dev(ls_grafico),
                    fill: false,
                    borderColor: '#004165'
                },
                {
                    label: 'Expo',
                    data: this.armar_cantidad_ret(ls_grafico),
                    fill: false,
                    borderColor: '#FF6303'
                }
            ]
        }

        this.impo_contador = this.contador_impo(ls_grafico);
        this.expo_contador = this.contador_expo(ls_grafico);
    }

    armar_meses(ls_grafico: Array<Grafico>) {
        var meses = [];

        for (let i = 0; i < ls_grafico.length; i++) {
            switch (ls_grafico[i].mes) {
                case "1":
                    meses.push("Enero - " + ls_grafico[i].anio)
                    break;
                case "2":
                    meses.push("Febrero - " + ls_grafico[i].anio)
                    break;
                case "3":
                    meses.push("Marzo - " + ls_grafico[i].anio)
                    break;
                case "4":
                    meses.push("Abril - " + ls_grafico[i].anio)
                    break;
                case "5":
                    meses.push("Mayo - " + ls_grafico[i].anio)
                    break;
                case "6":
                    meses.push("Junio - " + ls_grafico[i].anio)
                    break;
                case "7":
                    meses.push("Julio - " + ls_grafico[i].anio)
                    break;
                case "8":
                    meses.push("Agosto - " + ls_grafico[i].anio)
                    break;
                case "9":
                    meses.push("Setiembre - " + ls_grafico[i].anio)
                    break;
                case "10":
                    meses.push("Octubre - " + ls_grafico[i].anio)
                    break;
                case "11":
                    meses.push("Noviembre - " + ls_grafico[i].anio)
                    break;
                case "12":
                    meses.push("Diciembre - " + ls_grafico[i].anio)
                    break;
            }

        }
        return meses;
    }

    armar_cantidad_dev(ls_grafico: Array<Grafico>) {
        var cantidades = [];

        for (let i = 0; i < ls_grafico.length; i++) {
            cantidades.push(ls_grafico[i].cantidadDevolucion)
        }

        return cantidades;
    }

    armar_cantidad_ret(ls_grafico: Array<Grafico>) {
        var cantidades = [];

        for (let i = 0; i < ls_grafico.length; i++) {
            cantidades.push(ls_grafico[i].cantidadRetiro)
        }

        return cantidades;
    }


    impo_contador = 0;

    contador_impo(ls_grafico: Array<Grafico>) {
        var cont: number = 0;

        for (let i = 0; i < ls_grafico.length; i++) {
            cont = cont + Number(ls_grafico[i].cantidadDevolucion)
        }

        return cont;
    }

    expo_contador = 0;
    contador_expo(ls_grafico: Array<Grafico>) {
        var cont: number = 0;

        for (let i = 0; i < ls_grafico.length; i++) {
            cont = cont + Number(ls_grafico[i].cantidadRetiro)
        }

        return cont;
    }

    onEvent(event) {
        event.stopPropagation();
    }
}



// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/component/dashboard.component.ts